"use client";
import React from 'react';
import { motion } from 'framer-motion';
import { useContactModal } from '@/contexts/ContactModalContext';

export default function TechnicalSEOCTA() {
    const { openModal } = useContactModal();

    return (
        <section className="relative overflow-hidden py-10 md:py-24 px-4 md:px-16 lg:px-24"
            style={{ background: '#ffffff', borderTopLeftRadius: '80px', borderTopRightRadius: '80px' }}>
            <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle, rgba(55,48,163,1) 1px, transparent 1px)', backgroundSize: '36px 36px' }} />
            <div className="max-w-[900px] mx-auto relative z-10 text-center flex flex-col gap-10 items-center">
                <motion.span initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: '#3730a3', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}>Get In Touch</motion.span>
                <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
                    className="text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#080400' }}>
                    Is Your Website Technically Ready for Search?
                </motion.h2>
                <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 }}
                    className="text-base md:text-lg max-w-2xl"
                    style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(8,4,0,0.65)', lineHeight: '1.8', letterSpacing: '0.02em' }}>
                    Let&apos;s identify what&apos;s helping — and what&apos;s holding back — your organic visibility.
                </motion.p>
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }} className="flex flex-col sm:flex-row gap-4 items-center w-full sm:w-auto">
                    <button onClick={openModal} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 rounded-full font-semibold text-base md:text-lg transition-all duration-300 hover:scale-105"
                        style={{ background: '#3730a3', color: '#ffffff', fontFamily: 'var(--font-clash), "Clash Display", sans-serif', letterSpacing: '0.05em' }}>
                        Get a Technical SEO Audit →
                    </button>
                </motion.div>
                <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.3 }} className="text-xs"
                    style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(8,4,0,0.3)', letterSpacing: '0.05em' }}>
                    Lead Workz — Build for visibility. Optimised for revenue.
                </motion.p>
            </div>
        </section>
    );
}
